module.exports = __webpack_public_path__ + "static/media/a7.45e462fc.pdf";